/* eslint-disable no-shadow */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateRangePicker } from "react-dates";
import {
  faCalendar,
  faArrowRight,
  faChevronCircleLeft,
  faChevronCircleRight,
} from "@fortawesome/free-solid-svg-icons";
import { selectDateRangeFilter } from "../../../../actions/employerAnalyticsActions";
import { Wrapper, Filter, DatePickerWrapper } from "../filters-styles";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

export class DesktopDateFilter extends Component {
  state = {
    startDate: null,
    endDate: null,
  };

  render() {
    const { startDate, endDate, focusedInput } = this.state;
    const { selectDateRangeFilter, isOutsideRange, selectedDateRange } =
      this.props;
    return (
      <Wrapper date id="date-filter" data-test-id="date-filter">
        <Filter>
          <FontAwesomeIcon icon={faCalendar} />
          <DatePickerWrapper>
            <DateRangePicker
              startDateId="start-date-id"
              endDateId="end-date-id"
              startDate={startDate || selectedDateRange?.startDate}
              endDate={endDate || selectedDateRange?.endDate}
              onDatesChange={({ startDate, endDate }) => {
                this.setState({ startDate, endDate });
                console.log(this.state);
                selectDateRangeFilter({ startDate, endDate });
              }}
              orientation="horizontal"
              focusedInput={focusedInput}
              onFocusChange={(focusedInput) => {
                return this.setState({ focusedInput });
              }}
              hideKeyboardShortcutsPanel
              numberOfMonths={1}
              displayFormat="MMM DD, YYYY"
              navPrev={<FontAwesomeIcon icon={faChevronCircleLeft} />}
              navNext={<FontAwesomeIcon icon={faChevronCircleRight} />}
              customArrowIcon={<FontAwesomeIcon icon={faArrowRight} />}
              noBorder
              isOutsideRange={isOutsideRange}
              showClearDates
              minimumNights={1}
            />
          </DatePickerWrapper>
        </Filter>
      </Wrapper>
    );
  }
}

DesktopDateFilter.propTypes = {
  selectedDateRange: PropTypes.shape({
    startDate: PropTypes.shape({}),
    endDate: PropTypes.shape({}),
  }).isRequired,
  selectDateRangeFilter: PropTypes.func.isRequired,
  isOutsideRange: PropTypes.any.isRequired,
};

const mapStateToProps = (state) => ({
  selectedDateRange: state.employerAnalytics.selectedDateRange,
});

export default connect(mapStateToProps, { selectDateRangeFilter })(
  DesktopDateFilter
);
